import React from 'react';
import { Route, Routes } from 'react-router';
import { PagePath } from '../navigation.enums';
import { ActiveCompanySlugRedirect } from './routers.helpers';
import { useCompanySlugParamChange } from '../../library/hooks/useCompanySlugParamChange';
import { CreateAssessmentPage } from '../../pages/assessment-management/create/create-assessment.page';
import { GroupAssessmentPage } from '../../pages/assessment-management/group/group-assessment.page';
import { AssessmentManagementPage } from '../../pages/assessment-management/assessment-management.page';
import { RatingAssessmentPage } from '../../pages/assessment-management/rating/rating-assessment.page';
import { AssigneesPage } from '../../pages/assessment-management/assignees/assignees.page';
import { FOPAssessmentPage } from '../../pages/assessment-management/fop/fop-assessment.page';
import { QuestionnaireAssessmentPage } from '../../pages/assessment-management/questionnaire/questionnaire-assessment.page';
import { ViewRatingAssessmentPage } from '../../pages/assessment-management/rating/view-rating-assessment/view-rating-assessment.page';
import { EditActiveRatingAssessment } from '../../pages/assessment-management/rating/view-rating-assessment/edit-active-rating-assessment.page';

export function AssessmentManagementRouter(): JSX.Element {
  useCompanySlugParamChange(PagePath.assessmentManagementBase);

  return (
    <Routes>
      <Route path={PagePath.assessmentManagement} element={<AssessmentManagementPage />} />
      <Route path={PagePath.assessmentManagementCreate} element={<CreateAssessmentPage />} />
      <Route path={PagePath.assessmentManagementCreateRatingAssessment} element={<RatingAssessmentPage />} />
      <Route path={PagePath.assessmentManagementCreateGroupAssessment} element={<GroupAssessmentPage />} />
      <Route path={PagePath.assessmentManagementCreateFOPAssessment} element={<FOPAssessmentPage />} />
      <Route path={PagePath.assessmentManagementCreateQuestionnaireAssessment} element={<QuestionnaireAssessmentPage />} />
      <Route path={PagePath.assessmentManagementEditRatingAssessment} element={<RatingAssessmentPage />} />
      <Route path={PagePath.assessmentManagementEditGroupAssessment} element={<GroupAssessmentPage />} />
      <Route path={PagePath.assessmentManagementEditQuestionnaireAssessment} element={<QuestionnaireAssessmentPage />} />
      <Route path={PagePath.assessmentManagementEditFOPAssessment} element={<FOPAssessmentPage />} />
      <Route path={PagePath.assessmentManagementAssignees} element={<AssigneesPage />} /> {/* TODO: remove once all flows updated */}
      <Route path={PagePath.assessmentManagementViewRatingAssessment} element={<ViewRatingAssessmentPage />} />
      <Route path={PagePath.assessmentManagementEditActiveRatingAssessment} element={<EditActiveRatingAssessment />} />
      <Route path={PagePath.rootWildcard} element={<ActiveCompanySlugRedirect landingRedirectTo={`${PagePath.assessmentManagementBase}${PagePath.assessmentManagement}`} />} />
    </Routes>
  );
}
